import { render, staticRenderFns } from "./RegisteredPostDoc.vue?vue&type=template&id=007ff41a&"
import script from "./RegisteredPostDoc.vue?vue&type=script&lang=js&"
export * from "./RegisteredPostDoc.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredPostDoc.vue?vue&type=style&index=0&id=007ff41a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports